/* CHATS */
export const GET_NOTI = "GET_NOTI"
export const GET_NOTI_SUCCESS = "GET_NOTI_SUCCESS"